import React from 'react'
import {
  CustomerAgencyDatabaseShardAuditSnapshotV1,
  IAuditEventData,
} from '../../../api'
import { useDetailStyles } from './useDetailStyles'
import { Box } from 'cs-kevlar-react'
import { UnavailableDetails } from './UnavailableDetails'
import { resolveSnapshots } from './utils'
import { DetailField } from './DetailField'

interface CustomerAgencyDatabaseShardMigrationDetailsProps {
  eventData: IAuditEventData
}

export const CustomerAgencyDatabaseShardMigrationDetails: React.FunctionComponent<CustomerAgencyDatabaseShardMigrationDetailsProps> = ({
  eventData,
}) => {
  const classes = useDetailStyles()
  const [originalSnapshot, updatedSnapshot] = resolveSnapshots<
    CustomerAgencyDatabaseShardAuditSnapshotV1
  >(eventData, nameof<CustomerAgencyDatabaseShardAuditSnapshotV1>())
  const showDiff = !!originalSnapshot && !!updatedSnapshot

  if (!updatedSnapshot && !originalSnapshot) return <UnavailableDetails />

  return (
    <React.Fragment>
      <Box className={classes.fieldsContainer}>
        <DetailField
          label="Shard ID"
          showDiff={showDiff}
          original={originalSnapshot?.shardId?.toString()}
          updated={updatedSnapshot?.shardId?.toString()}
        />
      </Box>
    </React.Fragment>
  )
}
